import { useCallback, useState } from 'react';

function useSelection(initialSelected: string[] = []) {
  const [selected, setSelected] = useState<string[]>(initialSelected);

  const select = useCallback((ids: string[]) => {
    setSelected(current => Array.from(new Set([...current, ...ids])));
  }, []);

  const unselect = useCallback((ids: string[]) => {
    setSelected(current => current.filter(item => !ids.includes(item)));
  }, []);

  const toggle = useCallback(
    (id: string) => {
      const isSelected = selected.includes(id);
      isSelected ? unselect([id]) : select([id]);
      return !isSelected;
    },
    [selected, select, unselect],
  );

  const clear = useCallback(() => {
    setSelected([]);
  }, [setSelected]);

  return { selected, select, unselect, toggle, clear };
}

export default useSelection;
